// Copyright ©️ 2026 eVolve MEP, LLC

import Analytics from 'assets/icons/icon-src/analytics.svg?react';
import Assembly from 'assets/icons/icon-src/assembly.svg?react';
import AttachToItem from 'assets/icons/icon-src/attach-to-item.svg?react';
import Attachment from 'assets/icons/icon-src/attachment.svg?react';
import BarChart from 'assets/icons/icon-src/bar-chart.svg?react';
import BendCreator from 'assets/icons/icon-src/bend-creator.svg?react';
import BillOfMaterials from 'assets/icons/icon-src/bill-of-materials.svg?react';
import CalendarBoard from 'assets/icons/icon-src/calendar-board.svg?react';
import Catalog from 'assets/icons/icon-src/catalog.svg?react';
import Comment from 'assets/icons/icon-src/comment.svg?react';
import ContentRequest from 'assets/icons/icon-src/content-request.svg?react';
import DateProperty from 'assets/icons/icon-src/custom-properties/date-property.svg?react';
import DropdownProperty from 'assets/icons/icon-src/custom-properties/dropdown-property.svg?react';
import NumberProperty from 'assets/icons/icon-src/custom-properties/number-property.svg?react';
import TextProperty from 'assets/icons/icon-src/custom-properties/text-property.svg?react';
import ToggleProperty from 'assets/icons/icon-src/custom-properties/toggle-property.svg?react';
import Customers from 'assets/icons/icon-src/customers.svg?react';
import DrawingDocument from 'assets/icons/icon-src/drawing-document.svg?react';
import EmptyCircle from 'assets/icons/icon-src/empty-circle.svg?react';
import Encrypted from 'assets/icons/icon-src/encrypted.svg?react';
import Fabrication from 'assets/icons/icon-src/fabrication.svg?react';
import FrontView from 'assets/icons/icon-src/fabrication/front-view.svg?react';
import LayoutMarkings from 'assets/icons/icon-src/fabrication/layout-markings.svg?react';
import PerspectiveView from 'assets/icons/icon-src/fabrication/perspective-view.svg?react';
import QuickView from 'assets/icons/icon-src/fabrication/quick-view.svg?react';
import TopView from 'assets/icons/icon-src/fabrication/top-view.svg?react';
import Facility from 'assets/icons/icon-src/facility.svg?react';
import Folder from 'assets/icons/icon-src/folder.svg?react';
import External from 'assets/icons/icon-src/globe.svg?react';
import Hidden from 'assets/icons/icon-src/hidden.svg?react';
import History from 'assets/icons/icon-src/history.svg?react';
import AccessLock from 'assets/icons/icon-src/indicators/access-lock.svg?react';
import Alert from 'assets/icons/icon-src/indicators/alert.svg?react';
import Blocked from 'assets/icons/icon-src/indicators/blocked.svg?react';
import CheckAlert from 'assets/icons/icon-src/indicators/check-alert.svg?react';
import Check from 'assets/icons/icon-src/indicators/check.svg?react';
import Danger from 'assets/icons/icon-src/indicators/danger.svg?react';
import Help from 'assets/icons/icon-src/indicators/help.svg?react';
import Info from 'assets/icons/icon-src/indicators/info.svg?react';
import LightBulb from 'assets/icons/icon-src/indicators/light-bulb.svg?react';
import ResetPassword from 'assets/icons/icon-src/indicators/reset-password.svg?react';
import TrendingDown from 'assets/icons/icon-src/indicators/trending-down.svg?react';
import TrendingUp from 'assets/icons/icon-src/indicators/trending-up.svg?react';
import Unavailable from 'assets/icons/icon-src/indicators/unavailable.svg?react';
import Insights from 'assets/icons/icon-src/insights.svg?react';
import Kanban from 'assets/icons/icon-src/kanban.svg?react';
import Label from 'assets/icons/icon-src/labels.svg?react';
import ProductElectrical from 'assets/icons/icon-src/license/product-electrical.svg?react';
import ProductFabrication from 'assets/icons/icon-src/license/product-fabrication.svg?react';
import ProductMaterialAnalytics from 'assets/icons/icon-src/license/product-material-analytics.svg?react';
import ProductMechanical from 'assets/icons/icon-src/license/product-mechanical.svg?react';
import ProductRevitRoles from 'assets/icons/icon-src/license/product-revit-roles.svg?react';
import ProductShop from 'assets/icons/icon-src/license/product-shop.svg?react';
import ProductSSO from 'assets/icons/icon-src/license/product-sso.svg?react';
import ProductSync from 'assets/icons/icon-src/license/product-sync.svg?react';
import ProductUsageAnalytics from 'assets/icons/icon-src/license/product-usage-analytics.svg?react';
import Licenses from 'assets/icons/icon-src/licenses.svg?react';
import List from 'assets/icons/icon-src/list.svg?react';
import MaterialUsage from 'assets/icons/icon-src/material-usage.svg?react';
import Members from 'assets/icons/icon-src/members.svg?react';
import Message from 'assets/icons/icon-src/message.svg?react';
import MissingBom from 'assets/icons/icon-src/missing-bom.svg?react';
import ModelBrowser from 'assets/icons/icon-src/model-browser.svg?react';
import NavBarMenu from 'assets/icons/icon-src/nav-bar-menu.svg?react';
import Notification from 'assets/icons/icon-src/notification.svg?react';
import Part from 'assets/icons/icon-src/part.svg?react';
import PrecisionManufacturing from 'assets/icons/icon-src/precision-manufacturing.svg?react';
import Profile from 'assets/icons/icon-src/profile.svg?react';
import Project from 'assets/icons/icon-src/project.svg?react';
import Settings from 'assets/icons/icon-src/settings.svg?react';
import Shipment from 'assets/icons/icon-src/shipment.svg?react';
import Spools from 'assets/icons/icon-src/spools.svg?react';
import TableChart from 'assets/icons/icon-src/table-chart.svg?react';
import TableViews from 'assets/icons/icon-src/table-views.svg?react';
import TaskList from 'assets/icons/icon-src/task-list.svg?react';
import TimeTracking from 'assets/icons/icon-src/time-tracking.svg?react';
import ToggleShading from 'assets/icons/icon-src/toggle-shading.svg?react';
import Add from 'assets/icons/icon-src/user-actions/add.svg?react';
import Archive from 'assets/icons/icon-src/user-actions/archive.svg?react';
import ArrowDown from 'assets/icons/icon-src/user-actions/arrow-down.svg?react';
import ArrowLeft from 'assets/icons/icon-src/user-actions/arrow-left.svg?react';
import ArrowRight from 'assets/icons/icon-src/user-actions/arrow-right.svg?react';
import ClearFilters from 'assets/icons/icon-src/user-actions/clear-filters.svg?react';
import Close from 'assets/icons/icon-src/user-actions/close-icon.svg?react';
import CollapsePane from 'assets/icons/icon-src/user-actions/collapse-pane.svg?react';
import Copy from 'assets/icons/icon-src/user-actions/copy.svg?react';
import Delete from 'assets/icons/icon-src/user-actions/delete.svg?react';
import Download from 'assets/icons/icon-src/user-actions/download.svg?react';
import DraggableDivider from 'assets/icons/icon-src/user-actions/draggable-divider.svg?react';
import Draggable from 'assets/icons/icon-src/user-actions/draggable.svg?react';
import Edit from 'assets/icons/icon-src/user-actions/edit.svg?react';
import Exit from 'assets/icons/icon-src/user-actions/exit.svg?react';
import ExpandPane from 'assets/icons/icon-src/user-actions/expand-pane.svg?react';
import Export from 'assets/icons/icon-src/user-actions/export.svg?react';
import FilterAlt from 'assets/icons/icon-src/user-actions/filter-alt.svg?react';
import Filter from 'assets/icons/icon-src/user-actions/filter.svg?react';
import FollowLink from 'assets/icons/icon-src/user-actions/follow-link.svg?react';
import Isolate from 'assets/icons/icon-src/user-actions/isolate.svg?react';
import Link from 'assets/icons/icon-src/user-actions/link.svg?react';
import ManageTaskGroups from 'assets/icons/icon-src/user-actions/manage-task-groups.svg?react';
import Manage from 'assets/icons/icon-src/user-actions/manage.svg?react';
import Menu from 'assets/icons/icon-src/user-actions/menu-dropdown.svg?react';
import NavCollapseCollapsed from 'assets/icons/icon-src/user-actions/nav-collapse-collapsed.svg?react';
import NavCollapseOpen from 'assets/icons/icon-src/user-actions/nav-collapse-open.svg?react';
import NewTask from 'assets/icons/icon-src/user-actions/new-task.svg?react';
import Override from 'assets/icons/icon-src/user-actions/override.svg?react';
import Pause from 'assets/icons/icon-src/user-actions/paused.svg?react';
import Pin from 'assets/icons/icon-src/user-actions/pin.svg?react';
import Play from 'assets/icons/icon-src/user-actions/play.svg?react';
import Refresh from 'assets/icons/icon-src/user-actions/refresh.svg?react';
import Reset from 'assets/icons/icon-src/user-actions/reset.svg?react';
import Save from 'assets/icons/icon-src/user-actions/save.svg?react';
import Search from 'assets/icons/icon-src/user-actions/search.svg?react';
import Sort from 'assets/icons/icon-src/user-actions/sort.svg?react';
import Unlink from 'assets/icons/icon-src/user-actions/unlink.svg?react';
import Unpin from 'assets/icons/icon-src/user-actions/unpin.svg?react';
import Upload from 'assets/icons/icon-src/user-actions/upload.svg?react';
import Visible from 'assets/icons/icon-src/visible.svg?react';
import WorkCellTask from 'assets/icons/icon-src/work-cell-task.svg?react';
import WorkCells from 'assets/icons/icon-src/work-cells.svg?react';
import WorkOrder from 'assets/icons/icon-src/work-orders.svg?react';
import WriteInItem from 'assets/icons/icon-src/write-in-item.svg?react';
import WriteInValue from 'assets/icons/icon-src/write-in-value.svg?react';
/**
 * The map defining all possible EVOLVE icons
 */
export const iconMap = {
  AccessLock,
  Add,
  Alert,
  Analytics,
  Archive,
  // FIXME: New 24x24 icon needed
  ArrowDown,
  // FIXME: New 24x24 icon needed
  ArrowLeft,
  // FIXME: New 24x24 icon needed
  ArrowRight,
  Assembly,
  Attachment,
  AttachToItem,
  BarChart,
  BendCreator,
  BillOfMaterials,
  Blocked,
  CalendarBoard,
  Catalog,
  Check,
  CheckAlert,
  ClearFilters,
  Close,
  CollapsePane,
  Comment,
  ContentRequest,
  Copy,
  Customers,
  Danger,
  DateProperty,
  Delete,
  Download,
  DraggableDivider,
  Draggable,
  /** Deprecated, remove when "Drawings" are removed */
  DrawingDocument,
  DropdownProperty,
  Edit,
  EmptyCircle,
  Encrypted,
  Exit,
  ExpandPane,
  Export,
  External,
  Fabrication,
  Facility,
  Filter,
  FilterAlt,
  Folder,
  FollowLink,
  FrontView,
  Help,
  Hidden,
  History,
  Info,
  Insights,
  Isolate,
  Kanban,
  Label,
  LayoutMarkings,
  Licenses,
  LightBulb,
  Link,
  List,
  Manage,
  ManageTaskGroups,
  MaterialUsage,
  Members,
  Menu,
  Message,
  MissingBom,
  ModelBrowser,
  NavBarMenu,
  NavCollapseCollapsed,
  NavCollapseOpen,
  NewTask,
  Notification,
  NumberProperty,
  Override,
  Part,
  Pause,
  PerspectiveView,
  Pin,
  Play,
  PrecisionManufacturing,
  ProductElectrical,
  ProductFabrication,
  ProductMaterialAnalytics,
  ProductMechanical,
  ProductRevitRoles,
  ProductShop,
  ProductSSO,
  ProductSync,
  ProductUsageAnalytics,
  Profile,
  Project,
  QuickView,
  Refresh,
  Reset,
  ResetPassword,
  Save,
  Search,
  Settings,
  Sort,
  Shipment,
  Spools,
  TableChart,
  TableViews,
  TaskList,
  TimeTracking,
  TextProperty,
  ToggleProperty,
  ToggleShading,
  TopView,
  TrendingDown,
  TrendingUp,
  Unavailable,
  Unlink,
  Unpin,
  // FIXME: New 24x24 icon needed
  Upload,
  Visible,
  WorkCells,
  WorkCellTask,
  WorkOrder,
  WriteInItem,
  WriteInValue,
} as const;
